/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_ImplementersInputs */

const vi_care_log_implementers = /** @type {(inputs: Care_Log_ImplementersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người thực hiện`)
};

/**

* @param {Care_Log_ImplementersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_implementers = /** @type {((inputs?: Care_Log_ImplementersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_ImplementersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_implementers(inputs)
});